import * as CONSTS from "./consts";

// ── Session token (persists panel login) ──────────────────────
export function getUserToken() {
  return localStorage.getItem(CONSTS.ACCESS_TOKEN);
}

export function setUserToken(value) {
  return localStorage.setItem(CONSTS.ACCESS_TOKEN, value);
}

export function removeUserToken() {
  return localStorage.removeItem(CONSTS.ACCESS_TOKEN);
}

// ── Admin JWT (short-lived, for REST protected routes) ─────────
export function getJwtToken() {
  return sessionStorage.getItem(CONSTS.JWT_TOKEN);
}

export function setJwtToken(value) {
  return sessionStorage.setItem(CONSTS.JWT_TOKEN, value);
}

export function removeJwtToken() {
  return sessionStorage.removeItem(CONSTS.JWT_TOKEN);
}
